import React, { createContext, useState, useEffect, useContext } from "react";

// Modelo básico de usuario
export interface User {
  isAuthenticated: boolean;
  profile?: {
    name?: string;
    email?: string;
    [key: string]: any;
  };
  gigyaAccount?: any; // Puedes tipar esto mejor si tienes el modelo
}

// Contexto y provider
interface AuthContextType {
  user: User | null;
  setUser: React.Dispatch<React.SetStateAction<User | null>>;
}

export const AuthContext = createContext<AuthContextType>({
  user: null,
  setUser: () => {},
});

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [user, setUser] = useState<User | null>(null);

  // Aquí puedes agregar lógica para cargar el usuario desde cookies, localStorage, o una API
  useEffect(() => {
    try {
      // Ejemplo: cargar usuario desde localStorage
      const stored = localStorage.getItem("user");
      if (stored) {
        setUser(JSON.parse(stored));
      } else {
        setUser({ isAuthenticated: false });
      }
    } catch (err) {
      setUser({ isAuthenticated: false });
      // Puedes loguear el error si lo necesitas: console.error('Error cargando usuario:', err);
    }
    // Aquí podrías agregar lógica para validar sesión, refrescar token, etc.
  }, []);

  return (
    <AuthContext.Provider value={{ user, setUser }}>
      {children}
    </AuthContext.Provider>
  );
};

// Custom hook para consumir el contexto fácilmente
export const useAuth = () => useContext(AuthContext);
